import { BottomNavigation as MuiBottomNavigation } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { ROUTES } from 'theSource/app/routes';
import { Entries } from 'theSource/types';
import {
  BottomNavigationActionStyled,
  BottomNavigationContentStyled,
  BottomNavigationWrapperStyled,
} from './BottomNavigationStyled';
import { BOTTOM_NAVIGATION_ICONS } from './utils';
import { selectIsPageNotFoundActive } from '../PageNotFound/services';

interface BottomNavigationProps {
  hideNavigation?: boolean;
}

export const BottomNavigation = ({
  hideNavigation = false,
}: BottomNavigationProps) => {
  const { t } = useTranslation();
  const location = useLocation();
  const isPageNotFoundActive = useSelector(selectIsPageNotFoundActive);
  const [activeNavigationItemIndex, setActiveNavigationItemIndex] = useState(0);

  useEffect(() => {
    const firstLevelPathName = `/${location.pathname.split('/')[1]}`;
    const mainRoutes = Object.values(ROUTES.main);
    const routeIndex = mainRoutes.findIndex(
      (route) => route.path === firstLevelPathName
    );

    setActiveNavigationItemIndex(routeIndex > -1 ? routeIndex : -1);
  }, [location]);

  return (
    <>
      {!hideNavigation && (
        <BottomNavigationWrapperStyled data-testid="bottom-navigation">
          <BottomNavigationContentStyled elevation={3}>
            <MuiBottomNavigation
              showLabels
              value={!isPageNotFoundActive && activeNavigationItemIndex}
              onChange={(_, newValue) => {
                setActiveNavigationItemIndex(newValue);
              }}
            >
              {(Object.entries(ROUTES.main) as Entries<typeof ROUTES.main>).map(
                ([navigationItemKey, navigationItemValue], index) => (
                  <BottomNavigationActionStyled
                    disableRipple
                    component={Link}
                    to={navigationItemValue.path}
                    key={index}
                    label={t(navigationItemValue.name)}
                    icon={BOTTOM_NAVIGATION_ICONS[navigationItemKey]}
                  />
                )
              )}
            </MuiBottomNavigation>
          </BottomNavigationContentStyled>
        </BottomNavigationWrapperStyled>
      )}
    </>
  );
};
